import roomApi from '@/api/room';

const state = {
    list: null,
    fullList: null,
    roomCreated: null,
    roomUpdated: null,
    roomGroupCreated: null,
    roomGroupUpdated: null,
    isLoading: false,
    validationErrors: null,
}

export const mutationTypes = {
    roomListStart: '[room] List room start',
    roomListSuccess: '[room] List room success',
    roomListFailure: '[room] List room failure',

    roomFullListStart: '[room] Full list room start',
    roomFullListSuccess: '[room] Full list room success',
    roomFullListFailure: '[room] Full list room failure',

    roomCreateStart: '[room] Create room start',
    roomCreateSuccess: '[room] Create room success',
    roomCreateFailure: '[room] Create room failure',

    roomUpdateStart: '[room] Update room start',
    roomUpdateSuccess: '[room] Update room success',
    roomUpdateFailure: '[room] Update room failure',

    roomGroupCreateStart: '[room] Create group room start',
    roomGroupCreateSuccess: '[room] Create group room success',
    roomGroupCreateFailure: '[room] Create group room failure',

    roomGroupUpdateStart: '[room] Update group room start',
    roomGroupUpdateSuccess: '[room] Update group room success',
    roomGroupUpdateFailure: '[room] Update group room failure',
}

export const roomActionTypes = {
    roomList: '[room] List room',
    roomFullList: '[room] Full list room',
    roomCreate: '[room] Create room',
    roomUpdate: '[room] Update room',
    roomGroupCreate: '[room] Create group room',
    roomGroupUpdate: '[room] Update group room'
}

const mutations = {
    [mutationTypes.roomListStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.roomListSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.roomListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.roomFullListStart](state) {
        state.isLoading = true
        state.fullList = null
    },
    [mutationTypes.roomFullListSuccess](state, payload) {
        state.isLoading = false
        state.fullList = payload
        state.validationErrors = null
    },
    [mutationTypes.roomFullListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.roomCreateStart](state) {
        state.isLoading = true
        state.roomCreated = null
    },
    [mutationTypes.roomCreateSuccess](state, payload) {
        state.isLoading = false
        state.roomCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.roomCreateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.roomUpdateStart](state) {
        state.isLoading = true
        state.roomUpdated = null
    },
    [mutationTypes.roomUpdateSuccess](state, payload) {
        state.isLoading = false
        state.roomUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.roomUpdateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.roomGroupCreateStart](state) {
        state.isLoading = true
        state.roomGroupCreated = null
    },
    [mutationTypes.roomGroupCreateSuccess](state, payload) {
        state.isLoading = false
        state.roomGroupCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.roomGroupCreateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.roomGroupUpdateStart](state) {
        state.isLoading = true
        state.roomGroupUpdated = null
    },
    [mutationTypes.roomGroupUpdateSuccess](state, payload) {
        state.isLoading = false
        state.roomGroupUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.roomGroupUpdateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [roomActionTypes.roomList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.roomListStart)
            roomApi
                .roomList(data)
                .then(response => {
                    context.commit(mutationTypes.roomListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.roomListFailure,response)
                })
        })
    },
    [roomActionTypes.roomFullList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.roomFullListStart)
            roomApi
                .roomFullList(data)
                .then(response => {
                    context.commit(mutationTypes.roomFullListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.roomFullListFailure,response)
                })
        })
    },
    [roomActionTypes.roomCreate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.roomCreateStart)
            roomApi
                .roomCreate(data)
                .then(response => {
                    context.commit(mutationTypes.roomCreateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.roomCreateFailure,response)
                })
        })
    },
    [roomActionTypes.roomUpdate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.roomUpdateStart)
            roomApi
                .roomUpdate(data)
                .then(response => {
                    context.commit(mutationTypes.roomUpdateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.roomUpdateFailure,response)
                })
        })
    },
    [roomActionTypes.roomGroupCreate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.roomGroupCreateStart)
            roomApi
                .roomGroupCreate(data)
                .then(response => {
                    context.commit(mutationTypes.roomGroupCreateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.roomGroupCreateFailure,response)
                })
        })
    },
    [roomActionTypes.roomGroupUpdate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.roomGroupUpdateStart)
            roomApi
                .roomGroupUpdate(data)
                .then(response => {
                    context.commit(mutationTypes.roomGroupUpdateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.roomGroupUpdateFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}